import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Message, MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { PeopleService } from 'src/app/services/people.service';

@Component({
  selector: 'ness-compare-and-merge',
  templateUrl: './compare-and-merge.component.html',
  styleUrls: ['./compare-and-merge.component.scss']
})
export class CompareAndMergePeopleComponent implements OnInit, OnDestroy {
  private _unsubscribe$: Subject<void> = new Subject<void>();

  people: ServerModels.ENESS_Person[] = [];
  newPerson = {} as ServerModels.PersonMergeViewModel;
  personSelected: number = 0;

  width1: string;
  width2: string;
  width3: string;

  selectAll1: boolean = true;
  selectAll2: boolean = false;
  selectAll3: boolean = false;
  displayMerge: string = 'all';

  hideFirstName: boolean = false;
  hideMiddleName: boolean = false;
  hideLastName: boolean = false;
  hideSuffix: boolean = false;
  hideAlias: boolean = false;
  hideNickName: boolean = false;
  hideGenderID: boolean = false;
  hideRaceID: boolean = false;
  hideGangName: boolean = false;
  hideDateOfBirth: boolean = false;
  hideSSN: boolean = false;
  hidePhoneNumber: boolean = false;
  hideEmailAddress: boolean = false;
  hidePersonDescription: boolean = false;
  hideIsKnownFelon: boolean = false;
  hideFBI: boolean = false;
  hideStateId: boolean = false;
  hideCityId: boolean = false;
  hideSocial: boolean = false;
  hideDrivers: boolean = false;
  hideAddress: boolean = false;
  hideAttachments: boolean = false;

  mergePeopleValidationMessages: Message[] = [];

  constructor(private peopleService: PeopleService,
    private router: Router,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private vcr: ViewContainerRef) {  }

  ngOnInit() {
    const mergePeopleIds = sessionStorage.getItem('mergePeople');
    if (mergePeopleIds != null) {
      this.peopleService.getPersonsByStringOfIds(mergePeopleIds).pipe(takeUntil(this._unsubscribe$)).subscribe({
        next: (people: ServerModels.ENESS_Person[]) => {
          this.loadPeople(people);
        }
      })
    }
    else {
      this.return();
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  public loadPeople(personArray: ServerModels.ENESS_Person[]) {
    if (personArray.length < 2 || personArray.length > 3) {
      this.return();
    }
    else {
      this.people = personArray;
      this.newPerson.Person = JSON.parse(JSON.stringify(personArray[0]));
      this.newPerson.ExistingPersonId1 = personArray[0].PersonID;
      this.newPerson.ExistingPersonId2 = personArray[1].PersonID;
      if (personArray.length > 2) {
        this.width1 = '10%';
        this.width2 = this.width3 = '30%';
        this.newPerson.ExistingPersonId3 = personArray[2].PersonID;
      }
      else {
        this.newPerson.ExistingPersonId3 = null;
        this.width1 = '20%';
        this.width2 = '40%';
      }
    }
    this.cdr.detectChanges();
  }

  public return(): void {
    this.router.navigate(['/manageduplicates']);
  }

  public changeSort(value: string): void {
    this.displayMerge = value;
    if (value == 'all') {
      this.hideFirstName = false;
      this.hideMiddleName = false;
      this.hideLastName = false;
      this.hideSuffix = false;
      this.hideAlias = false;
      this.hideNickName = false;
      this.hideGenderID = false;
      this.hideRaceID = false;
      this.hideGangName = false;
      this.hideDateOfBirth = false;
      this.hideSSN = false;
      this.hidePhoneNumber = false;
      this.hideEmailAddress = false;
      this.hidePersonDescription = false;
      this.hideIsKnownFelon = false;
      this.hideFBI = false;
      this.hideStateId = false;
      this.hideCityId = false;
      this.hideSocial = false;
      this.hideDrivers = false;
      this.hideAddress = false;
      this.hideAttachments = false;
    }
    else {
      if (this.people.length == 2) {
        if (this.people[0].FirstName == this.people[1].FirstName) {
          this.hideFirstName = true;
        }
        if (this.people[0].MiddleName == this.people[1].MiddleName) {
          this.hideMiddleName = true;
        }
        if (this.people[0].LastName == this.people[1].LastName) {
          this.hideLastName = true;
        }
        if (this.people[0].Suffix == this.people[1].Suffix) {
          this.hideSuffix = true;
        }
        if (this.people[0].Alias == this.people[1].Alias) {
          this.hideAlias = true;
        }
        if (this.people[0].NickName == this.people[1].NickName) {
          this.hideNickName = true;
        }
        if (this.people[0].GenderID == this.people[1].GenderID) {
          this.hideGenderID = true;
        }
        if (this.people[0].RaceID == this.people[1].RaceID) {
          this.hideRaceID = true;
        }
        if (this.people[0].GangName == this.people[1].GangName) {
          this.hideGangName = true;
        }
        if (this.people[0].DateOfBirth == this.people[1].DateOfBirth) {
          this.hideDateOfBirth = true;
        }
        if (this.people[0].SSN == this.people[1].SSN) {
          this.hideSSN = true;
        }
        if (this.people[0].ENESS_XREF_PeoplePhoneNumbers.length == 0 && this.people[1].ENESS_XREF_PeoplePhoneNumbers.length == 0) {
          this.hidePhoneNumber = true;
        }
        if (this.people[0].ENESS_XREF_PeopleEmailAccounts.length == 0 && this.people[1].ENESS_XREF_PeopleEmailAccounts.length == 0) {
          this.hideEmailAddress = true;
        }
        if (this.people[0].PersonDescription == this.people[1].PersonDescription) {
          this.hidePersonDescription = true;
        }
        if (this.people[0].IsKnownFelon == this.people[1].IsKnownFelon) {
          this.hideIsKnownFelon = true;
        }
        if (this.people[0].ENESS_XREF_PeopleFBIFileNumbers.length == 0 && this.people[1].ENESS_XREF_PeopleFBIFileNumbers.length == 0) {
          this.hideFBI = true;
        }
        if (this.people[0].ENESS_XREF_PeopleStateIDNumbers.length == 0 && this.people[1].ENESS_XREF_PeopleStateIDNumbers.length == 0) {
          this.hideStateId = true;
        }
        if (this.people[0].ENESS_XREF_PeopleCityIDNumbers.length == 0 && this.people[1].ENESS_XREF_PeopleCityIDNumbers.length == 0) {
          this.hideCityId = true;
        }
        if (this.people[0].ENESS_XREF_PeopleSocialMedia.length == 0 && this.people[1].ENESS_XREF_PeopleSocialMedia.length == 0) {
          this.hideSocial = true;
        }
        if (this.people[0].ENESS_XREF_PeopleDriversLicense.length == 0 && this.people[1].ENESS_XREF_PeopleDriversLicense.length == 0) {
          this.hideDrivers = true;
        }
        if (this.people[0].ENESS_XREF_PeopleAddresses.length == 0 && this.people[1].ENESS_XREF_PeopleAddresses.length == 0) {
          this.hideAddress = true;
        }
        if (this.people[0].ENESS_XREF_PeopleAttachments.length == 0 && this.people[1].ENESS_XREF_PeopleAttachments.length == 0) {
          this.hideAttachments = true;
        }
      }
      else if (this.people.length == 3) {
        if (this.people[0].FirstName == this.people[1].FirstName && this.people[0].FirstName == this.people[2].FirstName) {
          this.hideFirstName = true;
        }
        if (this.people[0].MiddleName == this.people[1].MiddleName && this.people[0].MiddleName == this.people[2].MiddleName) {
          this.hideMiddleName = true;
        }
        if (this.people[0].LastName == this.people[1].LastName && this.people[0].LastName == this.people[2].LastName) {
          this.hideLastName = true;
        }
        if (this.people[0].Suffix == this.people[1].Suffix && this.people[0].Suffix == this.people[2].Suffix) {
          this.hideSuffix = true;
        }
        if (this.people[0].Alias == this.people[1].Alias && this.people[0].Alias == this.people[2].Alias) {
          this.hideAlias = true;
        }
        if (this.people[0].NickName == this.people[1].NickName && this.people[0].NickName == this.people[2].NickName) {
          this.hideNickName = true;
        }
        if (this.people[0].GenderID == this.people[1].GenderID && this.people[0].GenderID == this.people[2].GenderID) {
          this.hideGenderID = true;
        }
        if (this.people[0].RaceID == this.people[1].RaceID && this.people[0].RaceID == this.people[2].RaceID) {
          this.hideRaceID = true;
        }
        if (this.people[0].GangName == this.people[1].GangName && this.people[0].GangName == this.people[2].GangName) {
          this.hideGangName = true;
        }
        if (this.people[0].DateOfBirth == this.people[1].DateOfBirth && this.people[0].DateOfBirth == this.people[2].DateOfBirth) {
          this.hideDateOfBirth = true;
        }
        if (this.people[0].SSN == this.people[1].SSN && this.people[0].SSN == this.people[2].SSN) {
          this.hideSSN = true;
        }
        if (this.people[0].ENESS_XREF_PeoplePhoneNumbers.length == 0 && this.people[1].ENESS_XREF_PeoplePhoneNumbers.length == 0 &&
          this.people[2].ENESS_XREF_PeoplePhoneNumbers.length == 0) {
          this.hidePhoneNumber = true;
        }
        if (this.people[0].ENESS_XREF_PeopleEmailAccounts.length == 0 && this.people[1].ENESS_XREF_PeopleEmailAccounts.length == 0 &&
          this.people[2].ENESS_XREF_PeopleEmailAccounts.length == 0) {
          this.hideEmailAddress = true;
        }
        if (this.people[0].PersonDescription == this.people[1].PersonDescription && this.people[0].PersonDescription == this.people[2].PersonDescription) {
          this.hidePersonDescription = true;
        }
        if (this.people[0].IsKnownFelon == this.people[1].IsKnownFelon && this.people[0].IsKnownFelon == this.people[2].IsKnownFelon) {
          this.hideIsKnownFelon = true;
        }
        if (this.people[0].ENESS_XREF_PeopleFBIFileNumbers.length == 0 && this.people[1].ENESS_XREF_PeopleFBIFileNumbers.length == 0 &&
          this.people[2].ENESS_XREF_PeopleFBIFileNumbers.length == 0) {
          this.hideFBI = true;
        }
        if (this.people[0].ENESS_XREF_PeopleStateIDNumbers.length == 0 && this.people[1].ENESS_XREF_PeopleStateIDNumbers.length == 0 &&
          this.people[2].ENESS_XREF_PeopleStateIDNumbers.length == 0) {
          this.hideStateId = true;
        }
        if (this.people[0].ENESS_XREF_PeopleCityIDNumbers.length == 0 && this.people[1].ENESS_XREF_PeopleCityIDNumbers.length == 0 &&
          this.people[2].ENESS_XREF_PeopleCityIDNumbers.length == 0) {
          this.hideCityId = true;
        }
        if (this.people[0].ENESS_XREF_PeopleSocialMedia.length == 0 && this.people[1].ENESS_XREF_PeopleSocialMedia.length == 0 &&
          this.people[2].ENESS_XREF_PeopleSocialMedia.length == 0) {
          this.hideSocial = true;
        }
        if (this.people[0].ENESS_XREF_PeopleDriversLicense.length == 0 && this.people[1].ENESS_XREF_PeopleDriversLicense.length == 0 &&
          this.people[2].ENESS_XREF_PeopleDriversLicense.length == 0) {
          this.hideDrivers = true;
        }
        if (this.people[0].ENESS_XREF_PeopleAddresses.length == 0 && this.people[1].ENESS_XREF_PeopleAddresses.length == 0 &&
          this.people[2].ENESS_XREF_PeopleAddresses.length == 0) {
          this.hideAddress = true;
        }
        if (this.people[0].ENESS_XREF_PeopleAttachments.length == 0 && this.people[1].ENESS_XREF_PeopleAttachments.length == 0 &&
          this.people[2].ENESS_XREF_PeopleAttachments.length == 0) {
          this.hideAttachments = true;
        }
      }
    }
  }

  public checkAll(selection: string, checked: boolean) {
    // only select all if the box starts unchecked
    if (!checked) {
      if (selection == 'select1') {
        this.selectAll2 = this.selectAll3 = false;
        this.personSelected = 0;
        // create deep copy of selected person object selecting items from other people does not change appearance of selected persons values
        this.newPerson.Person = JSON.parse(JSON.stringify(this.people[0]));
      }
      else if (selection == 'select2') {
        this.selectAll1 = this.selectAll3 = false;
        this.newPerson.Person = JSON.parse(JSON.stringify(this.people[1]));
        this.personSelected = 1;
      }
      else {
        this.selectAll2 = this.selectAll1 = false;
        this.newPerson.Person = JSON.parse(JSON.stringify(this.people[2]));
        this.personSelected = 2;
      }
      this.cdr.detectChanges();
    }
  }

  updateFirstName(prop: string) {
    this.newPerson.Person.FirstName = prop;
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateMiddleName(prop: string) {
    this.newPerson.Person.MiddleName = prop;
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateLastName(prop: string) {
    this.newPerson.Person.LastName = prop;
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateSuffix(prop: string) {
    this.newPerson.Person.Suffix = prop;
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateAlias(prop: string) {
    this.newPerson.Person.Alias = prop;
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateNickName(prop: string) {
    this.newPerson.Person.NickName = prop;
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateGenderID(prop: ServerModels.ENESS_REF_Genders) {
    if (prop != null) {
      this.newPerson.Person.GenderID = prop.GenderID;
      this.newPerson.Person.ENESS_REF_Genders = prop;
    }
    else {
      this.newPerson.Person.GenderID = null;
      this.newPerson.Person.ENESS_REF_Genders = null;
    }
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateRaceID(prop: ServerModels.ENESS_REF_Races) {
    if (prop != null) {
      this.newPerson.Person.RaceID = prop.RaceID;
      this.newPerson.Person.ENESS_REF_Races = prop;
    }
    else {
      this.newPerson.Person.RaceID = null;
      this.newPerson.Person.ENESS_REF_Races = null;
    }
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateGangName(prop: string) {
    this.newPerson.Person.GangName = prop;
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateDateOfBirth(prop: Date) {
    this.newPerson.Person.DateOfBirth = prop;
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateSSN(prop: string) {
    this.newPerson.Person.SSN = prop;
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updatePhoneNumber(prop: string, checked: boolean, personArrayNumber: number) {
    if (checked) {
      this.newPerson.Person.ENESS_XREF_PeoplePhoneNumbers.push(this.people[personArrayNumber].ENESS_XREF_PeoplePhoneNumbers.find(x => x.PeoplePhoneNumbersID == prop));
    }
    else {
      this.newPerson.Person.ENESS_XREF_PeoplePhoneNumbers = this.newPerson.Person.ENESS_XREF_PeoplePhoneNumbers.filter(x => x.PeoplePhoneNumbersID != prop);
    }
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateIsPrimaryPhone(prop: string, personIndex: number, phoneIndex: number, checked: boolean) {
    let selectedItem = <HTMLInputElement>document.getElementById("phone-" + personIndex + "-" + phoneIndex);
    //make sure if they are changing the primary phone it is included in list of phone numbers for the new person
    if (this.newPerson.Person.ENESS_XREF_PeoplePhoneNumbers.filter(x => x.PeoplePhoneNumbersID === prop).length == 0) {
      selectedItem.checked = true;
      this.updatePhoneNumber(prop, true, personIndex);
    }
    if (checked) {
      //update all of their phone numbers so selected number is the primary
      this.newPerson.Person.ENESS_XREF_PeoplePhoneNumbers.find(x => x.PeoplePhoneNumbersID === prop).IsPrimary = true;
      this.newPerson.Person.ENESS_XREF_PeoplePhoneNumbers.filter(x => x.PeoplePhoneNumbersID !== prop).forEach(w => w.IsPrimary = false);
      //fix all of the radio buttons
      for (let i = 0; i < this.people.length; i++) {
        if (i == personIndex) {
          this.people[i].ENESS_XREF_PeoplePhoneNumbers[phoneIndex].IsPrimary = true;
          this.people[i].ENESS_XREF_PeoplePhoneNumbers.filter(x => x.PeoplePhoneNumbersID !== prop).forEach(y => y.IsPrimary = false);
        }
        else {
          this.people[i].ENESS_XREF_PeoplePhoneNumbers.forEach(x => x.IsPrimary = false);
        }
      }
    }
    else {
      this.newPerson.Person.ENESS_XREF_PeoplePhoneNumbers.find(x => x.PeoplePhoneNumbersID === prop).IsPrimary = false;
    }
  }

  updateEmailAddress(prop: string, checked: boolean, personArrayNumber: number) {
    let selectedEmail = this.people[personArrayNumber].ENESS_XREF_PeopleEmailAccounts.find(x => x.PeopleEmailAccountsID == prop);
    if (selectedEmail) {
      this.newPerson.Person.ENESS_XREF_PeopleEmailAccounts[0] = selectedEmail;
    } else {
      this.newPerson.Person.ENESS_XREF_PeopleEmailAccounts = []
    }
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updatePersonDescription(prop: string) {
    this.newPerson.Person.PersonDescription = prop;
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateIsKnownFelon(prop: boolean) {
    this.newPerson.Person.IsKnownFelon = prop;
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateFBINumbers(fbiNumber: string, checked: boolean, personArrayNumber: number) {
    if (checked) {
      this.newPerson.Person.ENESS_XREF_PeopleFBIFileNumbers.push(this.people[personArrayNumber].ENESS_XREF_PeopleFBIFileNumbers.find(x => x.PeopleFBIFileNumbersID == fbiNumber));
    }
    else {
      this.newPerson.Person.ENESS_XREF_PeopleFBIFileNumbers = this.newPerson.Person.ENESS_XREF_PeopleFBIFileNumbers.filter(x => x.PeopleFBIFileNumbersID != fbiNumber);
    }
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateStateIds(stateId: string, checked: boolean, personArrayNumber: number) {
    if (checked) {
      this.newPerson.Person.ENESS_XREF_PeopleStateIDNumbers.push(this.people[personArrayNumber].ENESS_XREF_PeopleStateIDNumbers.find(x => x.PeopleStateIDNumbersID == stateId));
    }
    else {
      this.newPerson.Person.ENESS_XREF_PeopleStateIDNumbers = this.newPerson.Person.ENESS_XREF_PeopleStateIDNumbers.filter(x => x.PeopleStateIDNumbersID != stateId);
    }
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateCityIds(cityId: string, checked: boolean, personArrayNumber: number) {
    if (checked) {
      this.newPerson.Person.ENESS_XREF_PeopleCityIDNumbers.push(this.people[personArrayNumber].ENESS_XREF_PeopleCityIDNumbers.find(x => x.PeopleCityIDNumbersID == cityId));
    }
    else {
      this.newPerson.Person.ENESS_XREF_PeopleCityIDNumbers = this.newPerson.Person.ENESS_XREF_PeopleCityIDNumbers.filter(x => x.PeopleCityIDNumbersID != cityId);
    }
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateSocialMedia(socMedia: string, checked: boolean, personArrayNumber: number) {
    if (checked) {
      this.newPerson.Person.ENESS_XREF_PeopleSocialMedia.push(this.people[personArrayNumber].ENESS_XREF_PeopleSocialMedia.find(x => x.PersonSocialMediaID == socMedia));
    }
    else {
      this.newPerson.Person.ENESS_XREF_PeopleSocialMedia = this.newPerson.Person.ENESS_XREF_PeopleSocialMedia.filter(x => x.PersonSocialMediaID != socMedia);
    }
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateDriversLicenses(dl: string, checked: boolean, personArrayNumber: number) {
    if (checked) {
      this.newPerson.Person.ENESS_XREF_PeopleDriversLicense.push(this.people[personArrayNumber].ENESS_XREF_PeopleDriversLicense.find(x => x.PeopleDriversLicenseID == dl));
    }
    else {
      this.newPerson.Person.ENESS_XREF_PeopleDriversLicense = this.newPerson.Person.ENESS_XREF_PeopleDriversLicense.filter(x => x.PeopleDriversLicenseID != dl);
    }
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateAddresses(add: string, checked: boolean, personArrayNumber: number) {
    if (checked) {
      this.newPerson.Person.ENESS_XREF_PeopleAddresses.push(this.people[personArrayNumber].ENESS_XREF_PeopleAddresses.find(x => x.PeopleAddressesID == add));
    }
    else {
      this.newPerson.Person.ENESS_XREF_PeopleAddresses = this.newPerson.Person.ENESS_XREF_PeopleAddresses.filter(x => x.PeopleAddressesID != add);
    }
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  updateIsPrimaryAddress(prop: string, personIndex: number, addressIndex: number, checked: boolean) {
    let selectedItem = <HTMLInputElement>document.getElementById("address-" + personIndex + "-" + addressIndex);
    //make sure if they are changing the primary address it is included in list of addresses for the new person
    if (this.newPerson.Person.ENESS_XREF_PeopleAddresses.filter(x => x.PeopleAddressesID === prop).length == 0) {
      selectedItem.checked = true;
      this.updateAddresses(prop, true, personIndex);
    }
    if (checked) {
      //update all of their addresses so selected number is the primary
      this.newPerson.Person.ENESS_XREF_PeopleAddresses.find(x => x.PeopleAddressesID === prop).IsCurrent = true;
      this.newPerson.Person.ENESS_XREF_PeopleAddresses.filter(x => x.PeopleAddressesID !== prop).forEach(w => w.IsCurrent = false);
      //fix all of the "Primary" check boxes
      for (let i = 0; i < this.people.length; i++) {
        if (i == personIndex) {
          this.people[i].ENESS_XREF_PeopleAddresses[addressIndex].IsCurrent = true;
          this.people[i].ENESS_XREF_PeopleAddresses.filter(x => x.PeopleAddressesID !== prop).forEach(y => y.IsCurrent = false);
        }
        else {
          this.people[i].ENESS_XREF_PeopleAddresses.forEach(x => x.IsCurrent = false);
        }
      }
    }
    else {
      this.newPerson.Person.ENESS_XREF_PeopleAddresses.find(x => x.PeopleAddressesID === prop).IsCurrent = false;
    }

  }

  updateAttachments(id: string, checked: boolean, personArrayNumber: number) {
    if (checked) {
      this.newPerson.Person.ENESS_XREF_PeopleAttachments.push(this.people[personArrayNumber].ENESS_XREF_PeopleAttachments.find(x => x.PersonAttachmentID == id));
    }
    else {
      this.newPerson.Person.ENESS_XREF_PeopleAttachments = this.newPerson.Person.ENESS_XREF_PeopleAttachments.filter(x => x.PersonAttachmentID != id);
    }
    this.selectAll1 = this.selectAll2 = this.selectAll3 = false;
  }

  public merge(): void {
    this.mergePeopleValidationMessages = [];
    if (this.newPerson.Person.ENESS_XREF_PeoplePhoneNumbers.filter(x => x.IsPrimary).length > 1) {
      this.mergePeopleValidationMessages.push({ severity: 'error', summary: 'Validation Message', detail: 'Only 1 "Primary" phone number allowed.' });
      return;
    }
    if ((this.newPerson.Person.ENESS_XREF_PeoplePhoneNumbers.length > 0) && !(this.newPerson.Person.ENESS_XREF_PeoplePhoneNumbers.find(x => x.IsPrimary))) {
      this.mergePeopleValidationMessages.push({ severity: 'error', summary: 'Validation Message', detail: 'A primary phone number is required' });
      return;
    }
    if (this.newPerson.Person.ENESS_XREF_PeopleAddresses.filter(x => x.IsCurrent).length > 1) {
      this.mergePeopleValidationMessages.push({ severity: 'error', summary: 'Validation Message', detail: 'Only 1 "Primary" address allowed.' });
      return;
    }
    this.newPerson.Person.PersonID = null;
    this.newPerson.Person.ModifiedBy = null;
    this.newPerson.Person.ModifiedOn = null;
    this.peopleService.mergePeople(this.newPerson).pipe(takeUntil(this._unsubscribe$)).subscribe({
      next: () => {
        sessionStorage.removeItem('mergePeople');
        this.return();
      },
      error: (err:any) => {
        let errorMsg: string = err?.error?.toString() ?? 'Unable to complete person merge.';
        this.messageService.clear();
        this.messageService.add({ key: 'personMergeMsg', severity: 'error', summary: '', detail: errorMsg });
        setTimeout(() => {
          this.vcr.element.nativeElement.getElementsByTagName('p-messages')[0]?.focus();
        }, 1000, this);
      }
    })
  }

}
